export const cmsKeys = {
  cmsHeaderLinks: (locale: string) => ['cmsHeaderLinks', locale],
  cmsPage: (qualifier: string, locale: string) => ['cmsPage', qualifier, locale],
  footer: (locale: string) => ['footer', locale],
  videoThumbnailUrl: (videoUrl: string) => ['videoThumbnailUrl', videoUrl],
};
